module.exports = __webpack_public_path__ + "img/mural.4f63dd0c.jpg";